import dayjs from 'dayjs';
import { EstateTask } from '/@/modules/estatetask/models/EstateTask';
import { EstateTaskUserStatus } from '/@/modules/estatetask/enums/EstateTaskUserStatus';
import { EstateTaskUserPriorityKey } from '@/modules/estatetask/enums/EstateTaskUserPriorityKey';
import { DateFormat } from '@/modules/core/app/constants/date.constants';
import { EstateTaskUserType } from '@/modules/estatetask/enums/EstateTaskUserType';
import { EstateTaskUserTypeKey } from '@/modules/estatetask/enums/EstateTaskUserTypeKey';

export class UserEstateTask extends EstateTask {
  constructor(model: Partial<UserEstateTask> = {}) {
    super(model);

    this.priority = model.priority ?? EstateTaskUserPriorityKey.LOW;
  }

  get isClosed(): boolean {
    return EstateTaskUserStatus.getDoneStatuses().includes(this.status);
  }

  get isCompleted(): boolean {
    return this.status === EstateTaskUserStatus.COMPLETED.key;
  }

  get displayDueDate(): string {
    if (this.dueDate && this.isClosed) {
      return dayjs(this.dueDate).format(DateFormat.MONTH_DAY_YEAR);
    }

    return super.displayDueDate;
  }

  get isBugVerification(): boolean {
    return this.type === EstateTaskUserTypeKey.BUG_VERIFICATION;
  }

  get timeEntryDescription(): string {
    return `${EstateTaskUserType.getByKey(this.type as string)?.value} - ${this.title}`;
  }
}
